import { useMutation } from '@tanstack/react-query';

import { goodsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';

export const removeGoodsItem: goodsTypes.RemoveItemData = ({ _id }) => {
  return axios.delete(`/goods/${_id}`);
};

type QueryFnType = typeof removeGoodsItem;

type UseRemoveGoodsItemOptions = {
  department: Departments;
  config?: MutationConfig<(params: Parameters<QueryFnType>[0]) => ReturnType<QueryFnType>>;
};

export function useRemoveGoodsItem({ config = {}, department }: UseRemoveGoodsItemOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['goods', department]);
    },
    ...config,
    mutationFn: removeGoodsItem,
  });
}
